import { clearError } from "./errorHandling";
import { updateError } from "./errorHandling";

export const validateAddSpaceStep1 = (
  formData,
  errors,
  setErrors,
  t,
  loading,
  setLoading
) => {
  let hasError = false;
  let updatedErrors = [...errors]; // Create a copy of the current errors array

  // Validate required fields for the first section (space details)
  if (!formData.place_type_id) {
    updatedErrors = updateError(
      "place_type_id",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("place_type_id", updatedErrors);
  }

  if (!formData.place_usage_id) {
    updatedErrors = updateError(
      "place_usage_id",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("place_usage_id", updatedErrors);
  }

  if (!formData.name) {
    updatedErrors = updateError(
      "name",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("name", updatedErrors);
  }

  // Validate required fields for address section
  if (!formData.address.address) {
    updatedErrors = updateError(
      "address",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("address", updatedErrors);
  }

  if (!formData.address.city) {
    updatedErrors = updateError(
      "city",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("city", updatedErrors);
  }

  if (!formData.address.country) {
    updatedErrors = updateError(
      "country",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("country", updatedErrors);
  }

  if (!formData.address.postal_code) {
    updatedErrors = updateError(
      "postal_code",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("postal_code", updatedErrors);
  }

  if (!formData.floor) {
    updatedErrors = updateError(
      "floor",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("floor", updatedErrors);
  }
  // Validate required fields for additional details (e.g., ad)
  if (!formData.title) {
    updatedErrors = updateError(
      "title",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("title", updatedErrors);
  }

  if (!formData.description) {
    updatedErrors = updateError(
      "description",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("description", updatedErrors);
  }

  // Set errors only if any validation failed
  if (hasError) {
    setErrors(updatedErrors);
    setLoading(false);
    return false;
  }

  setErrors(updatedErrors); // Clear all errors if validation passed
  return true;
};

export const validateAddSpaceStep3 = (
  formData,
  workingHours,
  errors,
  setErrors,
  t,
  loading,
  setLoading
) => {
  let hasError = false;
  let updatedErrors = [...errors]; // Create a copy of the current errors array

  // Validate required fields for price section
  if (!formData.price_day && formData.price_day !== 0) {
    updatedErrors = updateError(
      "price_hour",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("price_hour", updatedErrors);
  }

  if (!formData.price_half_day && formData.price_half_day !== 0) {
    updatedErrors = updateError(
      "price_half_day",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("price_half_day", updatedErrors);
  }

  if (!formData.price_day && formData.price_day !== 0) {
    updatedErrors = updateError(
      "price_day",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("price_day", updatedErrors);
  }


  if (!formData.minimal_duration) {
    updatedErrors = updateError(
      "minimal_duration",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("minimal_duration", updatedErrors);
  }

  if (formData.placeUsage?.key === "seminar" && !formData.minimal_capacity) {
    updatedErrors = updateError(
      "minimal_capacity",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("minimal_capacity", updatedErrors);
  }

  // Validate working hours section (if necessary, check if the day is selected or valid)
  if (workingHours && typeof workingHours === "object") {
    const allSlotsEmpty = Object.values(workingHours).every(
      (dayData) => dayData.slots === "0".repeat(48) // Check if all slots for the day are empty
    );

    // If no slots have "1" (meaning no working hours selected), set error
    if (allSlotsEmpty) {
      updatedErrors = updateError(
        "workingHours",
        t("validation.required"),
        updatedErrors
      );
      hasError = true;
    } else {
      updatedErrors = clearError("workingHours", updatedErrors); // Clear error if slots are valid
    }
  } else {
    // Handle the case where workingHours is undefined or not an object
    updatedErrors = updateError(
      "workingHours",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  }

  console.log("step3Errors", updatedErrors);
  // Set errors only if any validation failed
  if (hasError) {
    setErrors(updatedErrors);
    setLoading(false);
    return false;
  }

  setErrors(updatedErrors); // Clear all errors if validation passed
  return true;
};
